module.exports = __webpack_public_path__ + "images/experience_header_mobile.ed4d3fb2.jpg";